var map = {
	"./B1.jpg": 83518,
	"./Benchmark.jpg": 13772,
	"./Digital globe.jpg": 82798,
	"./Efficiency.png": 34998,
	"./Final1.jpg": 45056,
	"./LoRRI.png": 21029,
	"./Multimodal.jpg": 2935,
	"./No Internet.png": 18593,
	"./RightPartner3.jpg": 83814,
	"./Star.png": 15437,
	"./Truck.png": 88948,
	"./bidirectional.jpg": 90084,
	"./box.svg": 76694,
	"./gis_route.svg": 27756,
	"./gmaps-marker.svg": 26730,
	"./location_dashboard.jpg": 41389,
	"./logo-lorri.png": 51595,
	"./logo.png": 42996,
	"./logo3.png": 20869,
	"./myTransporter-banner.jpg": 92250,
	"./plus-icon.svg": 75083,
	"./road-sign.svg": 69733,
	"./road.png": 91523,
	"./search-glass.jpg": 68022,
	"./transporter.jpg": 80255,
	"./transporter_logo.png": 99513,
	"./truck-marker-2.svg": 24842,
	"./warehouse.png.png": 79151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81126;